(function () {
	const readFlags = (root) => ({
		mobile: root.dataset.carouselMobile === "true",
		tablet: root.dataset.carouselTablet === "true",
		desktop: root.dataset.carouselDesktop === "true",
	});

	const shouldEnableSwiper = (width, flags) => {
		if (width < 990) return flags.mobile;
		if (width < 1200) return flags.tablet;
		return flags.desktop;
	};

	const getSpaceBetween = (width) => (width >= 1200 ? 32 : 24);

	const swipers = new WeakMap();
	const observed = new WeakSet();

	const teardown = (root, container, wrapper, items, destroyInstance) => {
		const instance = swipers.get(root);
		if (instance && destroyInstance) instance.destroy(true, true);
		swipers.delete(root);

		container.classList.remove("swiper", "swiper--multicolumn");
		wrapper.classList.remove("swiper-wrapper");

		items.forEach((item) => {
			item.classList.remove("swiper-slide");
			item.removeAttribute("style");
		});

		root.classList.remove("multicolumn--carousel-active");
	};

	const syncRoot = (root) => {
		const container = root.querySelector(".multicolumn-list--carousel-capable");
		if (!container) return;

		const wrapper = container.querySelector(".multicolumn-list__wrapper");
		if (!wrapper) return;

		const items = container.querySelectorAll(".multicolumn-list__item");
		const flags = readFlags(root);

		// if all flags off, ensure we never keep a swiper instance around
		if (!flags.mobile && !flags.tablet && !flags.desktop) {
			teardown(root, container, wrapper, items, true);
			return;
		}

		const width = root.getBoundingClientRect().width;
		const enable = shouldEnableSwiper(width, flags);
		const instance = swipers.get(root);

		if (enable) {
			root.classList.add("multicolumn--carousel-active");

			if (!instance) {
				items.forEach((item) => item.classList.add("swiper-slide"));
				container.classList.add("swiper", "swiper--multicolumn");
				wrapper.classList.add("swiper-wrapper");

				const prev = root.querySelector(".swiper-button-prev");
				const next = root.querySelector(".swiper-button-next");

				const swiper = new Swiper(container, {
					slidesPerView: 1,
					spaceBetween: getSpaceBetween(width),
					watchOverflow: true,
					loop: false,
					speed: 1100,
					navigation: {
						nextEl: next,
						prevEl: prev,
					},
				});

				swipers.set(root, swiper);
			} else {
				instance.params.spaceBetween = getSpaceBetween(width);
				instance.update();
			}
		} else if (instance) {
			teardown(root, container, wrapper, items, true);
		} else {
			root.classList.remove("multicolumn--carousel-active");
		}
	};

	const observeRoot = (root) => {
		if (observed.has(root)) {
			syncRoot(root);
			return;
		}
		observed.add(root);

		const ro = new ResizeObserver(() => syncRoot(root));
		ro.observe(root);
		syncRoot(root);
	};

	document
		.querySelectorAll("[data-multicolumn-root]")
		.forEach(observeRoot);

	document.addEventListener("shopify:section:load", (event) => {
		event.target
			.querySelectorAll("[data-multicolumn-root]")
			.forEach(observeRoot);
	});
})();
